import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListQueryParameters, ISnMapResponse } from '@lib/api';
import { SnOffender } from '@lib/api/entities';

@Injectable({ providedIn: 'root' })
export class SnOffendersAPI {
  constructor(private readonly _httpClient: HttpClient) {}

  public getList(params?: ISnListQueryParameters): Observable<ISnMapResponse<SnOffender>> {
    return this._httpClient.get('/api/offenders/', { params }).pipe(
      map((response: any) => ({
        count: response.count,
        totalPages: response.totalPages,
        results: response.results.map((offender) => new SnOffender(offender)),
        clusterResults: response.clusterResults || [],
      })),
    );
  }

  public get(id: string): Observable<SnOffender> {
    return this._httpClient
      .get(`/api/offenders/${id}/`)
      .pipe(map((response: any) => new SnOffender(response)));
  }
}
